module.exports = __webpack_public_path__ + "img/second-bg-container.49d96d28.jpg";